import React from 'react';
import { Link } from '@naf-simba/elements-links';
import { OpenInNew } from '@naf-simba/building-blocks-icons/Arrows';
import { useResolveLink } from '../../../../../hooks/useResolveLink';
import { ArticleBlockContentGridCol } from './ArticleBlockContentGridCol';
import { BlockContentContext } from '../../../BlockContent.utils';

interface ExternalLinkSerializerProps {
  value: { text: string; blank?: boolean; link: string };
}

export const ExternalLink = ({ value: { text, blank, link } }: ExternalLinkSerializerProps) => {
  const { isInternal, linkProps } = useResolveLink(link);
  if (isInternal) {
    return blank ? (
      <Link href={linkProps.to} text={text} target="_blank" rel="noreferrer" />
    ) : (
      <Link href={linkProps.to} text={text} />
    );
  }

  return blank ? (
    <Link href={link} text={text} endIcon={OpenInNew} target="_blank" rel="noreferrer" />
  ) : (
    <Link href={link} text={text} endIcon={OpenInNew} />
  );
};

export const ExternalLinkSerializer = (context: BlockContentContext = BlockContentContext.Stripped) => {
  if (context === BlockContentContext.Article) {
    return ({ value }: ExternalLinkSerializerProps) => (
      <ArticleBlockContentGridCol className="externalLink">
        <ExternalLink value={value} />
      </ArticleBlockContentGridCol>
    );
  }
  return ({ value }: ExternalLinkSerializerProps) => <ExternalLink value={value} />;
};
